import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

const Block = ({ title, children }) => (
  <div className="mt-10">
    <h3 className="font-serif-display text-xl text-[#F3E5AB]">{title}</h3>
    <div className="mt-3 space-y-3 text-sm text-slate-400 leading-relaxed">{children}</div>
  </div>
);

export default function LegalNotice({ open, onClose }) {
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          data-testid="legal-notice-modal"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[70] bg-[#0A1120] overflow-y-auto"
        >
          <div className="mx-auto max-w-3xl px-6 py-20">
            <div className="flex items-start justify-between gap-6">
              <h2 className="font-serif-display text-3xl sm:text-4xl text-white">
                Mentions légales <span className="italic text-gold-gradient">& confidentialité</span>
              </h2>
              <button
                data-testid="legal-notice-close-button"
                onClick={onClose}
                className="shrink-0 rounded-full border border-[#D4AF37]/40 p-3 text-slate-300 transition-colors hover:bg-[#D4AF37] hover:text-[#0A1120]"
                aria-label="Fermer"
              >
                <X size={20} />
              </button>
            </div>

            <Block title="Éditrice du site">
              <p>Frédérique Vasseur — Entrepreneure individuelle</p>
              <p>1 Avenue du 8 Mai 1945, 34740 Vendargues, France</p>
              <p>SIRET : 521 449 819 00031 — Directrice de la publication : Frédérique Vasseur</p>
              <p>Contact : contact@frederiquevasseur.com — 07 44 77 44 45</p>
            </Block>

            <Block title="Hébergement">
              <p>Site hébergé par Emergent — Emergent Labs, Inc., infrastructure cloud sécurisée, HTTPS inclus.</p>
            </Block>

            <Block title="Propriété intellectuelle">
              <p>
                L'ensemble des contenus du site (textes, monogramme FV, photographies, identité visuelle)
                est la propriété exclusive de Frédérique Vasseur. Toute reproduction, même partielle,
                est interdite sans autorisation écrite préalable.
              </p>
            </Block>

            <Block title="Données personnelles (RGPD)">
              <p>
                Les formulaires de contact et de prise de rendez-vous collectent uniquement les informations
                nécessaires au traitement de votre demande : nom, adresse email, numéro de téléphone et
                contenu de votre message.
              </p>
              <p>
                Ces données sont utilisées exclusivement pour vous recontacter, ne sont ni vendues ni
                transmises à des tiers, et sont conservées pour une durée maximale de 3 ans.
              </p>
              <p>
                Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi
                Informatique et Libertés, vous disposez d'un droit d'accès, de rectification et de
                suppression de vos données. Pour l'exercer, écrivez-moi via le formulaire de contact.
              </p>
            </Block>

            <Block title="Cookies">
              <p>
                Ce site n'utilise aucun cookie publicitaire ou de suivi. Seules des données techniques
                strictement nécessaires au fonctionnement du site peuvent être traitées.
              </p>
            </Block>

            <p className="mt-14 text-xs text-slate-600">
              Dernière mise à jour : août 2026 — © {new Date().getFullYear()} Frédérique Vasseur
            </p>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
